import { useSearchParams } from "react-router";

import { useTasks } from "../api/hooks";
import { TaskRows } from "../components/TaskList";
import { EmptyState, ErrorState } from "../components/ui";
import { useNow } from "../lib/useNow";

const GROUPS = [
  ["overdue", "Overdue"],
  ["today", "Today"],
  ["upcoming", "Coming up"],
  ["undated", "No date"],
] as const;

function Group({
  due,
  label,
  assignee,
  now,
}: {
  due: string;
  label: string;
  assignee: string;
  now: number;
}) {
  const tasks = useTasks({ due, assignee });
  if (tasks.isError) return <ErrorState error={tasks.error} onRetry={() => void tasks.refetch()} />;
  if (!tasks.data?.length) return null;
  return (
    <>
      <div className="group-label eyebrow">
        {label} · {tasks.data.length}
      </div>
      <TaskRows tasks={tasks.data} now={now} />
    </>
  );
}

export function Tasks() {
  const [params, setParams] = useSearchParams();
  const assignee = params.get("assignee") ?? "me";
  const now = useNow(30_000);
  const any = useTasks({ assignee });
  return (
    <div className="page" style={{ maxWidth: 960 }}>
      <div className="page-head">
        <div>
          <h1>Agenda</h1>
          <p>
            Callbacks booked on calls and work added by hand, by when they are due. Tick one off, or
            push it an hour.
          </p>
        </div>
        <div className="actions">
          <div className="seg" role="tablist" aria-label="Assigned to">
            {(
              [
                ["me", "Mine"],
                ["any", "Everyone's"],
              ] as const
            ).map(([v, l]) => (
              <button
                key={v}
                role="tab"
                aria-selected={assignee === v}
                onClick={() => setParams(v === "me" ? {} : { assignee: v }, { replace: true })}
              >
                {l}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="card">
        {any.data?.length === 0 ? (
          <EmptyState icon="checkSquare" title="Nothing open">
            A callback booked on the desk's wrap-up lands here at its time.
          </EmptyState>
        ) : (
          GROUPS.map(([due, label]) => (
            <Group key={due} due={due} label={label} assignee={assignee} now={now} />
          ))
        )}
      </div>
    </div>
  );
}
